// extracted by mini-css-extract-plugin
export default {"fileContainer":"certificationPublicFile_fileContainer__Am12j","fileItem":"certificationPublicFile_fileItem__lppEH"};